"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideType = void 0;
var SlideType;
(function (SlideType) {
    SlideType["CATEGORY_TILE"] = "category-tile";
    SlideType["TEASER"] = "teaser";
    SlideType["SINGLE_PRODUCT_TILE"] = "single-product-tile";
    SlideType["CONTENT_TILE"] = "content-tile";
    SlideType["VIDEO"] = "video";
})(SlideType || (exports.SlideType = SlideType = {}));
//# sourceMappingURL=SliderTypes.js.map